const sentryConfigs = {
  dsn: process.env.REACT_APP_SENTRY_DSN,
};

export default sentryConfigs;
